import React from 'react'

const VolumetryMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_103_17197)"
      fillOpacity="0.1"
    />
    <g clipPath="url(#clip0_103_17197)">
      <path
        d="M16.2001 15.2853C16.2693 15.4403 16.3502 15.5899 16.4421 15.7326L23.6835 14.2919C23.3883 13.2547 22.8859 12.2882 22.2065 11.4507C21.5272 10.6133 20.685 9.92228 19.731 9.41957C18.777 8.91685 17.7309 8.61285 16.656 8.52594C15.5812 8.43903 14.4999 8.57102 13.4775 8.91393L16.2001 15.2853Z"
        fill="#052351"
      />
      <path
        d="M16.4207 17.6614C15.7892 17.1782 15.2915 16.5419 14.9747 15.8127L12.2513 9.43738C11.2184 9.98304 10.3175 10.7485 9.61229 11.6798C8.90703 12.6111 8.41447 13.6857 8.16927 14.8279C7.92408 15.9701 7.9322 17.1522 8.19308 18.2909C8.45396 19.4296 8.96125 20.4974 9.67925 21.4189C10.3972 22.3404 11.3085 23.0934 12.3489 23.6248C13.3892 24.1562 14.5334 24.4532 15.7009 24.4947C16.8684 24.5363 18.0308 24.3214 19.1063 23.8653C20.1818 23.4092 21.1443 22.7229 21.926 21.8547L16.4207 17.6614Z"
        fill="#052351"
      />
      <path
        d="M17.5768 16.866L22.7375 20.7994C23.5622 19.5171 24.0005 18.0246 24.0001 16.5C23.999 16.199 23.981 15.8983 23.9461 15.5994L17.5768 16.866Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_103_17197"
        x1="15.7922"
        y1="0.5"
        x2="15.7922"
        y2="32.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_103_17197">
        <rect width="16" height="16" fill="white" transform="translate(8 8.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default VolumetryMenu
